"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _LinkedSalesObjectActions = _interopRequireDefault(require("crm_ui/flux/integrations/LinkedSalesObjectActions"));

var _sidebarIntegrationActionTypes = _interopRequireDefault(require("crm_ui/constants/sidebarIntegrationActionTypes"));

var _Confirm = _interopRequireDefault(require("UIComponents/prompts/Confirm"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _default = (0, _createReactClass.default)({
  displayName: 'ProfileIntegrationsAction',
  propTypes: {
    action: _propTypes.default.instanceOf(_immutable.Map).isRequired,
    applicationId: _propTypes.default.number,
    appName: _propTypes.default.string,
    associatedObjectId: _propTypes.default.number.isRequired,
    associatedObjectType: _propTypes.default.oneOf([_ObjectTypes.CONTACT, _ObjectTypes.COMPANY, _ObjectTypes.DEAL]).isRequired,
    buttonClassName: _propTypes.default.string,
    buttonSize: _propTypes.default.string,
    buttonUse: _propTypes.default.string,
    iframeParentTitle: _propTypes.default.string.isRequired,
    objectId: _propTypes.default.number,
    objectTypeId: _propTypes.default.number.isRequired,
    openIframeModal: _propTypes.default.func.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      buttonSize: 'default',
      buttonUse: 'secondary'
    };
  },
  openConfirmationModal: function openConfirmationModal() {
    var action = this.props.action;

    var confirmButtonText = action.get('confirmButtonText') || _I18n.default.text('profileSidebarModule.integrations.actionConfirmationConfirm');

    var cancelButtonText = action.get('cancelButtonText') || _I18n.default.text('profileSidebarModule.integrations.actionConfirmationCancel');

    return (0, _Confirm.default)({
      message: _I18n.default.text('profileSidebarModule.integrations.actionConfirmationHeader'),
      description: action.get('confirmationMessage'),
      confirmLabel: confirmButtonText,
      rejectLabel: cancelButtonText
    }).then(this.doActionHook, function () {
      return null;
    }).done();
  },
  doActionHook: function doActionHook() {
    var _this$props = this.props,
        action = _this$props.action,
        applicationId = _this$props.applicationId,
        appName = _this$props.appName,
        associatedObjectId = _this$props.associatedObjectId,
        associatedObjectType = _this$props.associatedObjectType,
        objectId = _this$props.objectId,
        objectTypeId = _this$props.objectTypeId;
    var data = {
      applicationId: applicationId,
      applicationName: appName,
      integrationName: appName,
      associatedObjectProperties: action.get('associatedObjectProperties'),
      httpMethod: action.get('httpMethod'),
      uri: action.get('uri'),
      associatedObjectId: associatedObjectId,
      associatedObjectType: associatedObjectType,
      objectId: objectId,
      objectTypeId: objectTypeId
    };
    return _LinkedSalesObjectActions.default.doActionHook(data, action.get('label'));
  },
  onActionClick: function onActionClick() {
    var _this$props2 = this.props,
        action = _this$props2.action,
        iframeParentTitle = _this$props2.iframeParentTitle,
        openIframeModal = _this$props2.openIframeModal;
    var type = action.get('type');

    switch (type) {
      case _sidebarIntegrationActionTypes.default.IFRAME:
        return openIframeModal(action, iframeParentTitle);

      case _sidebarIntegrationActionTypes.default.ACTION_HOOK:
        return this.doActionHook();

      case _sidebarIntegrationActionTypes.default.CONFIRMATION_ACTION_HOOK:
        return this.openConfirmationModal();

      default:
        return null;
    }
  },
  render: function render() {
    var _this$props3 = this.props,
        action = _this$props3.action,
        buttonClassName = _this$props3.buttonClassName,
        buttonSize = _this$props3.buttonSize,
        buttonUse = _this$props3.buttonUse;
    var label = action.get('label');
    return _react.default.createElement(_UIButton.default, {
      use: buttonUse,
      size: buttonSize,
      onClick: this.onActionClick,
      className: buttonClassName
    }, label);
  }
});

exports.default = _default;
module.exports = exports.default;